import { useAppState } from "../contexts/AppContext";
import Login from "./login";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Auth, { checkAuth, logout, me } from "../helpers/Auth";
import { useEffect } from "react";
import { Link } from "@inertiajs/react";


dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)



export default function App({ children }: { children: React.ReactNode }) {
    const { appState, setAppState } = useAppState()

    useEffect(() => {
        Auth.me().then((data) => {
            setAppState({
                user: {
                    name: data.user.name,
                    email: data.user.email,
                }
            })
        })
    }, [])

    useEffect(() => {
        console.log(appState.user)
    }, [appState.user])

    if (!checkAuth()) {
        return <Login />
    }

    return (
        <div className="">
            <header className="w-full">
                <nav className=" mx-auto px-4 sm:px-6 lg:px-8 py-10 flex items-center justify-between">
                    <ul>
                        <li>
                            <Link className="text-lg font-medium" href="/">Crypto.titarlab.com</Link>
                        </li>

                    </ul>
                    <ul className="flex space-x-9">
                        <li>
                            <Link className="" href="/">Dashboard</Link>
                        </li>
                        <li>
                            <a href="#" onClick={logout}>Logout ({appState.user?.email})</a>
                        </li>
                    </ul>
                </nav>
            </header>
            <div className=" mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col">
                {children}
            </div>
        </div>
    )
}
